import { Nav, NavItem } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./StaffSidebar.css";

const navigation = [
  {
    title: "Dashboard",
    href: "/inspector-dashboard",
    icon: "bi bi-speedometer2",
  },
  {
    title: "Pending Inspections",
    href: "/inspector-dashboard/pending-inspections",
    icon: "bi bi-clipboard-check",
  },
  {
    title: "Inspection Schedule",
    href: "/inspector-dashboard/inspection-schedule",
    icon: "bi bi-calendar3",
  },
  {
    title: "Property Search",
    href: "/inspector-dashboard/property-search",
    icon: "bi bi-search",
  },
  {
    title: "Inspection History",
    href: "/inspector-dashboard/inspection-history",
    icon: "bi bi-clock-history",
  },
  {
    title: "Submit Report",
    href: "/inspector-dashboard/submit-report",
    icon: "bi bi-file-earmark-text",
  },
  {
    title: "My Profile",
    href: "/inspector-dashboard/profile",
    icon: "bi bi-person-badge",
  },
];

const InspectorSidebar = () => {
  const location = useLocation();
  const { userEmail } = useAuth();

  return (
    <div className="p-3">
      <div className="d-flex align-items-center pb-4 border-bottom">
        <div>
          <h5 className="mb-0 text-white">Inspector Portal</h5>
          <small className="text-white-50">{userEmail}</small>
        </div>
      </div>
      <div className="pt-4 mt-2">
        <Nav vertical className="sidebarNav">
          {navigation.map((navi, index) => (
            <NavItem key={index} className="sidenav-bg">
              <Link
                to={navi.href}
                className={
                  location.pathname === navi.href
                    ? "text-white nav-link py-3 active-link"
                    : "nav-link text-white-50 py-3"
                }
              >
                <i className={navi.icon}></i>
                <span className="ms-3 d-inline-block">{navi.title}</span>
              </Link>
            </NavItem>
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default InspectorSidebar;
